import { render, staticRenderFns } from "./CatalogLocationInfo.vue.html?vue&type=template&id=e54eabb6&"
import script from "./CatalogLocationInfo.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogLocationInfo.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogLocationInfo.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports